import moment from "moment";
import { Path, UseFormGetValues } from "react-hook-form";

export const backendDateFormat = "YYYY-MM-DD HH:mm:ss";

export const nearestMinutes = (moment): string => {
  const interval = 15;
  const minutesFactor = moment.minute() % interval;
  const roundedMinutes =
    minutesFactor < interval / 2
      ? Math.floor(moment.minute() / interval) * interval
      : Math.ceil(moment.minute() / interval) * interval;
  return moment.clone().minute(roundedMinutes).second(0);
};

export const formatTime = (seconds: number, withSeconds?: boolean): string => {
  const d = Math.floor(seconds / (3600 * 24));
  const h = Math.floor((seconds % (3600 * 24)) / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const sec = m * 60;
  return `${d > 0 ? d + "d " : ""}${h > 0 ? h + "h " : ""}${
    m > 0 ? m + " min " : withSeconds ? `0:${seconds - sec} min` : ""
  }`;
};

export const ConvertSecondsToMinutesSeconds = (time: number) => {
  const minutes = Math.floor(time / 60);
  const seconds = time % 60 === 0 ? "00" : time % 60;
  return `${minutes}:${seconds > 0 && seconds < 10 ? `0${seconds}` : seconds}`;
};

/**
 *
 * @describe Checking if data is in boundries of one day, if not, cut it to the 23:45
 */
export const getSessionEndTime = (
  assignmentDate: string | moment.Moment,
  durationSecond: number
): string => {
  const sessionEndDate = moment(assignmentDate)
    .add(durationSecond, "seconds")
    .format("YYYY-MM-DD HH:mm:00");
  const isTheSameDay = moment(sessionEndDate).isSame(assignmentDate, "day");
  return isTheSameDay ? sessionEndDate : moment(assignmentDate).format("YYYY-MM-DD 23:45:00");
};

export const getFormattedDueDate = (date: Date | string | null, days: number = 7): string => {
  return nearestMinutes(
    moment(
      new Date(
        moment(date).add(days, "days").format("MM/DD/YYYY") + " " + moment().format("hh:mm a")
      )
    )
  );
};

export const getFormattedAssignmentDate = (date: Date | string | null): string => {
  return nearestMinutes(
    moment(
      moment(date).format("MM/DD/YYYY") + " " + moment().format("hh:mm a"),
      "MM/DD/YYYY hh:mm a"
    )
  );
};

/**
 * @params:
 * - getValues : getValues function of useForm
 * - minName : name of the minimal value to check
 * - maxName : name of the maximal value to check
 * - elementName : name of the element to be checked
 * */

export const getMinMaxDates = <T>(
  getValues: UseFormGetValues<T>,
  minName: string,
  maxName: string,
  elementName: string
) => {
  let minMaxParams = {};
  if (elementName === maxName) {
    minMaxParams["minDate"] = new Date(
      elementName === maxName ? getValues(minName as Path<T>)?.toString() : ""
    );
  }
  if (elementName === minName) {
    minMaxParams["maxDate"] = new Date(
      elementName === minName && getValues(maxName as Path<T>)
        ? (getValues(maxName as Path<T>) as string)
        : "2056-12-31T00:00:00Z"
    );
  }

  return minMaxParams;
};
